import { Navbar, Footer } from "@/components/landing";
import { AboutContent } from "@/components/about/AboutContent";

export function AboutPage() {
  return (
    <div className="page text-ink">
      <Navbar />
      <main>
        <div className="h-24 lg:h-28" aria-hidden="true" />
        <AboutContent />
      </main>
      <Footer />
    </div>
  );
}
